import React, { useEffect, useState, Suspense, Children } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import Loading from "../LoadinScreen/Loading";
import { getToken, removeToken } from "../../utils/setAuthToken";
import { Helmet } from "react-helmet";

const DefaultLayout = ({ page }) => {
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isAuthenticated, allowedRoutes, allowedRoutesLoading } = useAuth();
  const [loading, setLoading] = useState(true);
  const token = getToken();

  useEffect(() => {
    if (!isAuthenticated && !allowedRoutesLoading) {
      removeToken();
      navigate("/login", { replace: true });
    } else if (allowedRoutesLoading) {
      setLoading(true);
    } else if (isAuthenticated && token && window.location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, allowedRoutes, allowedRoutesLoading, navigate]);

  // Toggle Menu open : Close
  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  useEffect(() => {
    toggleSidebar();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full text-center">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>All Leads | EV-INDIA</title>
      </Helmet>
      <div className="flex h-full gap-0 p-5 screen-wrapper xl:gap-5">
        <Sidebar
          collapsed={collapsed}
          allowedRoutes={allowedRoutes}
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
        <div
          className={`flex-1 flex flex-col gap-5 h-full w-full transition-width duration-300 ${collapsed ? "w-[calc(100%-120px)!important]" : "w-[calc(100%-290px)!important]"}`}
        >
          <Header
            className="sticky top-0 z-10 bg-white shadow-md p-4 "
            toggleSidebar={toggleSidebar}
            allowedRoutes={allowedRoutes}
            setIsMobileMenuOpen={setIsMobileMenuOpen}
          />
          <main className="flex-1 max-h-[calc(100%-82px)] overflow-hidden">
            <Suspense
              fallback={
                <div className="flex justify-center items-center text-center">
                  <Loading />
                </div>
              }
            >
              <div className="flex flex-col gap-5 h-[calc(100%)]">
                <div className="w-full h-[calc(100%-3px)] rounded-global overflow-y-auto">
                  {page || <Outlet />}
                </div>
              </div>
            </Suspense>
          </main>
        </div>
      </div>
    </>
  );
};

export default DefaultLayout;
